export const getCurrentCoordinates = ({ timeoutMs = 10000, maximumAge = 0, enableHighAccuracy = true } = {}) => new Promise((resolve, reject) => {
  if (!navigator?.geolocation) {
    reject(new Error('Geolocation is not supported by this device.'));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (position) => {
      resolve({
        latitude: Number(position.coords.latitude),
        longitude: Number(position.coords.longitude),
        accuracy: Number(position.coords.accuracy),
      });
    },
    (error) => {
      reject(error);
    },
    {
      enableHighAccuracy,
      timeout: timeoutMs,
      maximumAge,
    }
  );
});

const APP_DEVICE_ID_KEY = 'rp_app_device_id';

const createFallbackDeviceId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return `web-${crypto.randomUUID()}`;
  }
  return `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getAppDeviceId = async () => {
  try {
    const existing = localStorage.getItem(APP_DEVICE_ID_KEY);
    if (existing && existing.trim()) return existing;

    const next = createFallbackDeviceId();
    localStorage.setItem(APP_DEVICE_ID_KEY, next);
    return next;
  } catch (error) {
    return null;
  }
};

export const formatCoordinates = (latitude, longitude) => {
  if (!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))) return '';
  return `${Number(latitude).toFixed(6)}, ${Number(longitude).toFixed(6)}`;
};
